import {createApp} from "vue";
import SearchToggleIcon from "./components/SearchToggleIcon";
import SearchOverlay from "./components/SearchOverlay";
import SearchWholePageBackground from "./components/SearchWholePageBackground";

const searchBarRoot = document.getElementById('search-bar-root');
if(searchBarRoot){

    createApp({
        components: {
            SearchToggleIcon,
            SearchOverlay,
            SearchWholePageBackground
        },
        data(){
            return {
                isSearchOverlayEnabled: false
            }
        },
        props: {
            themeUri: String,
            restUri: String,
            homeUri: String,
            recommendedPosts: String    //  Is given JSON array.
        },
        provide(){
            return {
                themeUri: this.themeUri,
                restUri: this.restUri,
                homeUri: this.homeUri,
                recommendedPosts: JSON.parse(this.recommendedPosts),
                localization: cccl10n || {}
            }
        },
        methods: {
            onToggleSearchOverlay(){
                this.isSearchOverlayEnabled = !this.isSearchOverlayEnabled;
            }
        },
        template: `
          <search-toggle-icon @click="onToggleSearchOverlay"></search-toggle-icon>
          
          <teleport to="#search-overlay-hook" v-if="isSearchOverlayEnabled">
            <search-overlay></search-overlay>
          </teleport>
          <teleport to="body" v-if="isSearchOverlayEnabled">
            <search-whole-page-background @click="onToggleSearchOverlay"></search-whole-page-background>
          </teleport>
        `
    }, {...searchBarRoot.dataset}).mount(searchBarRoot);

}